var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 2.23A.774.774 0 0 1 5.708 1.6h6.346c2.1 0 3.617.458 4.503 1.362.886.904 1.196 2.184.92 3.802-.09.525-.228 1.01-.415 1.453a5.62 5.62 0 0 1-.823 1.3c-.38.43-.836.79-1.365 1.077-.529.286-1.141.499-1.832.637-.691.138-1.47.208-2.332.208H8.725a.774.774 0 0 0-.764.63l-.885 5.238z",
    fill: "#003087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.468 7.632c-.09.525-.228 1.01-.415 1.453a5.62 5.62 0 0 1-.823 1.3c-.38.43-.836.79-1.365 1.077-.529.286-1.141.499-1.832.637-.691.138-1.47.208-2.332.208H9.716a.774.774 0 0 0-.764.63l-1.1 6.5a.641.641 0 0 0 .633.74h3.36a.677.677 0 0 0 .67-.552l.5-2.96a.677.677 0 0 1 .668-.552h1.47c3.065 0 5.312-1.248 5.99-4.855.3-1.6.148-2.88-.637-3.77a3.97 3.97 0 0 0-.828-.665 5.5 5.5 0 0 1-.204.809z",
    fill: "#0070BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.726641805c80120084c93a5dd48adaf0.svg";
export { ForwardRef as ReactComponent };